import * as z from "zod";

const validationScehma = z.object({
  lineId: z.number().min(1, "required"),
  orderId: z.number().min(1, "required"),
});

export const MatchOrderToWeightReportLineSchema = validationScehma;

export type MatchOrderToWeightReportLineFormInput = z.infer<typeof MatchOrderToWeightReportLineSchema>;
